import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import { Link } from "react-router-dom";
import service from "../../assets/images/banner/web-development.png";
import basebg from "../../assets/images/resource/base.png";
import g1 from "../../assets/images/resource/we-dev.png";
import videoSource from "../../assets/videos/vdo-5.mp4";

const DigitalMarketing = () => {
  pageTitle("Web development");

 
  const servicesData = [
    { id: 1, title: "AI WhatsApp Agents", slug: "/Whatsapp-estore" },
    { id: 2, title: "RPA", slug: "/RPA-AI" },
    { id: 3, title: "Data & Analytics", slug: "/Data-Analytics" },
    // { id: 4, title: "Web Development", slug: "/Web-Development" },
    // { id: 5, title: "Digital Consulting", slug: "/digital-consultancy" },
  ];

  const renderServices = () => {
    return servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/digital-marketing" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };

  // Sidebar content component for reusability
  const SidebarContent = () => (
    <>
      <div
        className="sidebar__widget_network"
        style={{ backgroundImage: `url(${basebg})` }}
      >
        <h3 style={{ paddingBottom: "20px" }}>Web Development</h3>
        <video controls style={{ width: "100%", marginRight: "10px" }}>
          <source src={videoSource} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="sidebar__widget">
        <div className="all__service">
          <h4>All Services</h4>
        </div>
        <ul className="service__details__1__cat">{renderServices()}</ul>
      </div>
    </>
  );

  return (
    <>
      <HeaderOne></HeaderOne>
      <section className="page__title p_relative">
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${g1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div className="auto-container">
          <div className="content__box p_relative"></div>
        </div>
      </section>

      <div className="service__details p_relative ">
        <div className="auto-container">
          <div className="row">
            {/* Main content - appears first on both desktop and mobile */}
            <div className="col-xl-8 col-lg-12 col-md-12">
              <div className="service__right">
                <figure>
                  <img src={service} alt="" className="service-images" />
                </figure>
                <h2 className="wd">
                  Building Innovative Web Solutions for the Digital Era.
                </h2>
                <p>
                  <h4 style={{ padding: "0 0 20px" }}>
                    Seamless Integration of web application with OpenAPI and
                    Single Sign-On
                  </h4>
                  Our web Application's web-based service integrates seamlessly
                  with an OpenAPI interface to deliver a dynamic and
                  user-centric experience. The system is designed to provide
                  secure and efficient access through a single sign-on (SSO)
                  mechanism, ensuring that users can authenticate themselves
                  effortlessly across multiple services without needing to
                  repeatedly log in. By leveraging OpenAPI, our platform ensures
                  robust interoperability, enabling smooth communication between
                  various components and external APIs, whether for fetching
                  real-time data, updating user preferences, or integrating
                  third-party tools. web's dynamic and component-based
                  architecture ensures that the user interface remains highly
                  responsive and visually appealing, adapting intuitively to
                  different user needs. The SSO functionality streamlines the
                  user experience by reducing login friction while maintaining a
                  high level of security through encrypted token-based
                  authentication, making the platform not only user-friendly but
                  also trustworthy. This setup allows developers to scale and
                  maintain the service efficiently, offering users a seamless
                  and cohesive interaction with all the tools and features
                  available on the web Application.
                </p>
              </div>
            </div>

            {/* Desktop sidebar - only visible on desktop */}
            <div className="col-xl-4 col-lg-6 col-md-12 d-none d-xl-block">
              <div className="service__details__left">
                <SidebarContent />
              </div>
            </div>

            {/* Additional content section */}
            <div className="col-12">
              <div className="wd">
                <h4>e-Commerce Website Development</h4>
                <p>
                  Create an interactive, robust and user-friendly multi-vendor
                  e-commerce store for your retail business. Sell products
                  worldwide and increase revenue upto 10 times with your own
                  e-commerce marketplace. Our dedicated team of e-Commerce
                  experts support businesses to build a customer-centric eStores
                  and enhance user experience with the help of advanced
                  technologies, omnichannel presence, and customized solutions.
                </p>

                <h4>Responsive Web Application Development</h4>
                <p>
                  Building attractive & customised responsive websites thats
                  works on any devices. We aim to provide the best user mobile
                  and web experiences for our customers. Beautiful website. SEO
                  implementation. Customised Design. Many Singaporeans today
                  surf the Internet on their phones. We make websites
                  mobile-responsive so your buyers can purchase from you any
                  time, any day, and anywhere!
                </p>

                <h4>Web Application Maintenance</h4>
                <p>
                  Website maintenance is the most effective and cost- efficient
                  when it's done continuously.
                  <ul className="pt-2">
                    <li>
                      1. Review your website design and structure - can be it
                      improved?
                    </li>
                    <li>
                      2. Review SEO and meta titles and descriptions to ensure
                      they are as effective as possible
                    </li>
                    <li>
                      3. Test and tweak popups, forms, and calls to action
                    </li>
                    <li>
                      4. Review your workload for efficiencies to see if
                      anything can be automated
                    </li>
                    <li>
                      5. Test your website on all devices and browsers to see if
                      it displays correctly
                    </li>
                  </ul>
                </p>

                <h4>Mobile App Development</h4>
                <p>
                  We convert your website to an android mobile application and
                  send you the app (.apk file) ready to launch. We convert your
                  website to an iOs mobile application and send you the app
                  ready to launch, so you can submit it to the App Store. How it
                  works Submit your website URL | We deliver your app | Upload
                  to App Store or Play Store.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-4">
        <div className="row de-category">
          <div className="col-lg-6 col-md-12">
            <li>
              <Link to="/responsive" target="_blank" className="blinking">
                <i className="icon-04"></i> Responsive Design
              </Link>
            </li>
          </div>
          <div className="col-lg-6 col-md-12">
            <li>
              <Link to="/performance" target="_blank" className="blinking">
                <i className="icon-04"></i> Performance Optimization
              </Link>
            </li>
          </div>
          <div className="col-lg-6 col-md-12">
            <li>
              <Link to="/seo" target="_blank" className="blinking">
                <i className="icon-04"></i>SEO-Friendly Architecture
              </Link>
            </li>
          </div>
          <div className="col-lg-6 col-md-12">
            <li>
              <Link to="/security" target="_blank" className="blinking">
                <i className="icon-04"></i> Security
              </Link>
            </li>
          </div>
        </div>
      </div>

      {/* Mobile sidebar content - appears at the VERY END on mobile (after categories) */}
      <div className="d-block d-xl-none">
        <div className="auto-container">
          <div className="row">
            <div className="col-12">
              <div className="service__details__left mt-4">
                <SidebarContent />
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterOne></FooterOne>
    </>
  );
};

export default DigitalMarketing;
